import { endpoints, fetcherSwr } from "../utils/axios";
import { useMemo } from "react";
import useSWR from "swr";

const DEFAULT_PAGINATION = {
  total: 0,
  page: 1,
  limit: 20,
  totalPages: 0,
};

export function useGetScreenings(args = {}) {
  const hasParams = Object.keys(args).length > 0;

  const URL = hasParams
    ? [endpoints.screening.getScreenings, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(
    URL,
    fetcherSwr
  );

  return useMemo(
    () => ({
      screenings: data?.data || [],
      pagination: data?.pagination || DEFAULT_PAGINATION,
      isLoading,
      error,
      isValidating,
    }),
    [data, error, isLoading, isValidating]
  );
}